<template>
  <div>
    <el-button type="primary" circle="" @click="displaySetting" style="background-color: #fff; color: #3d5396">
      <FAIcon :custom-style="{ 'margin-right': 0 }" :color="Colors.MAIN_THEME" icon="fas fa-sliders-h" />
    </el-button>
    <el-dialog :visible.sync="settingPlagiarism" width="30%">
      <div class="title_popup text-center"><i class="fas fa-sliders-h"></i> Cài đặt kết quả hiển thị</div>
      <el-form label-width="120px" label-position="top">
        <div class="label_form_item">Chế độ sắp xếp:</div>
        <el-form-item>
          <el-col :span="24">
            <el-radio v-model="sortPlagModeType" :label="SortPlagMode.SEQUENCE" border>Thứ tự xuất hiện </el-radio>
          </el-col>
          <el-col :span="24">
            <el-radio v-model="sortPlagModeType" :label="SortPlagMode.SCORE_DESC" border
              >Mức độ sao chép giảm dần
            </el-radio>
          </el-col>
          <el-col :span="24">
            <el-radio v-model="sortPlagModeType" :label="SortPlagMode.SCORE_ASC" border
              >Mức độ sao chép tăng dần
            </el-radio>
          </el-col>
        </el-form-item>

        <div class="label_form_item">Lọc theo mức độ tương đồng:</div>
        <el-form-item>
          <el-col :span="24">
            <el-checkbox-group v-model="filterPlagScoresType">
              <el-checkbox :label="PlagScoreType.HIGH">Cao</el-checkbox>
              <el-checkbox :label="PlagScoreType.MEDIUM">Trung bình</el-checkbox>
              <el-checkbox :label="PlagScoreType.LOW">Thấp</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-form-item>

        <div class="label_form_item">Lọc nâng cao</div>
        <el-form-item>
          <el-col :span="24">
            <el-checkbox v-model="filterPlagSystemIgnore">Nội dung hệ thống không kiểm tra </el-checkbox>
          </el-col>
          <el-col :span="24">
            <el-checkbox v-model="filterPlagUserIgnore">Kết quả người dùng đã đánh dấu loại bỏ </el-checkbox>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onApplyFilter"><i class="fas fa-sliders-h"></i> Áp dụng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Colors, PlagScoreType, SortPlagMode } from '@/constants/DoITConstant'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'FilterForm',
  data: () => {
    return {
      settingPlagiarism: false,
      SortPlagMode,
      sortPlagModeType: SortPlagMode.SEQUENCE,
      PlagScoreType,
      filterPlagScoresType: [PlagScoreType.LOW, PlagScoreType.MEDIUM, PlagScoreType.HIGH],
      filterPlagSystemIgnore: true,
      filterPlagUserIgnore: true,
      Colors,
    }
  },
  components: {
    FAIcon,
  },
  methods: {
    displaySetting() {
      this.settingPlagiarism = true
      this.$store.dispatch('docRes/plagiarism/updateIsShowPlagPopup', false)
    },
    onApplyFilter() {
      this.settingPlagiarism = false
      this.$emit('submit', {
        sortPlagModeType: this.sortPlagModeType,
        filterPlagScoresType: this.filterPlagScoresType,
        filterPlagSystemIgnore: this.filterPlagSystemIgnore,
        filterPlagUserIgnore: this.filterPlagUserIgnore,
      })
    },
  },
}
</script>

<style scoped></style>
